export const StreamlineCheck = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.6512 15.1843L6.7812 19.673C7.4585 20.2657 8.492 20.1797 9.0619 19.4831L22.349 3.2432"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
